
import { BestellungFiliale, Terminart } from "mangdto"
import RestPaths from "@/util/rest_paths"
import Vue from "vue"
import Component from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"

@Component
export default class BestellungRow extends Vue {
  @Prop() bestellung: any
  @Prop() filiale: BestellungFiliale

  bestimmeBild(filiale: BestellungFiliale): string {
    if (filiale.bildId != null) {
      return RestPaths.imageBasePath + filiale.bildId + "_klein.jpg"
    }
  }

  computeTerminartText(value: string): string {
    switch (value) {
      case Terminart.Abholung:
        return "Abholung"
      case Terminart.Lieferung:
        return "Lieferung"
      case Terminart.Sofortbestellung:
        return "Tischbestellung"
    }
  }

  computeTerminartIcon(value: string): string {
    switch (value) {
      case Terminart.Abholung:
        return "$vuetify.icons.abholung"
      case Terminart.Reservierung:
        return "$vuetify.icons.reservierung"
      case Terminart.Sofortbestellung:
        return "$vuetify.icons.sofortbestellung"
      case Terminart.Lieferung:
        return "mdi-moped-outline"
    }
  }

  @Emit("detailsAnzeigen")
  detailsAnzeigen() {}
}
